module.exports = __webpack_public_path__ + "static/media/report_3.ea9b0a4b.jpg";